import { css } from "@emotion/react";
import { FC } from "react";
import { BaseProps } from "./text";

type Props = {
  children: string | JSX.Element | JSX.Element[];
} & BaseProps;

const GText: FC<Props> = ({
  children,
  fontSize,
  fontFamily,
  letterSpacing,
  color,
}) => {
  const textStyle = css`
    font-size: ${fontSize ? fontSize + "px" : "inherit"};
    letter-spacing: ${letterSpacing ? letterSpacing + "px" : "inherit"};
    color: ${color ? color : "inherit"};
    font-weight: ${fontFamily?.fontWeight ? fontFamily?.fontWeight : "inherit"};
    font-family: ${fontFamily?.fontFamily ? fontFamily?.fontFamily : "inherit"};
    & a,
    & h1,
    & h2,
    & h3,
    & h4,
    & h5,
    & h6 {
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }
  `;

  return <div css={textStyle}>{children}</div>;
};

export default GText;
